import React from 'react';
import PageHeader from '../common/PageHeader';
import PageFilter from '../common/PageFilter';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { controlType } from '../../constants/common';
import { apiBatchRequest, apiPost, downloadReport } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import { ShowToast, toastType } from '../../utils/toast-service';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import {
  varianceColumnsPropertyList,
  variancePropertyReportConfigList,
  radioValue
} from '../../constants/MockData';
import {
  applyFilterOnData,
  IsSectionVisible,
  mapOrder,
  UpdateColumnWithConfiguration,
  GenerateAbsoluteURL,
  IsSensitiveDataAccess,
  getCurrentPayCycleStartDate,
  getCurrentPayCycleEndDate,
  getCurrentPayCycle,
  cloneDeep,
  IsAutoRunPagesEnabled
} from '../../utils/helper';
import { Operators, SECTIONS } from '../../constants/appConstants';
import moment from 'moment';
import 'jspdf-autotable';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import {
  IconButton,
  Tooltip,
  FormControl,
  FormControlLabel,
  Radio,
  Checkbox,
  RadioGroup
} from '@material-ui/core';
import _ from 'lodash';
import PrintIcon from '@material-ui/icons/Print';
import GridEditTable from '../common/EditTable/EditTable';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Reports from '../Reports/Reports';
import PageLandingMessage from '../common/PageLandingMessage/PageLandingMessage';

class ReimbursementVarianceAnalysis extends React.PureComponent {
  // Constructor to define the state
  constructor(props) {
    super(props);
    this.state = {
      showMain: false,
      configuration: [],
      detailView: false,
      dateRangePrior: [],
      dateRangeNext: [],
      selectedEditRowId: undefined,
      legalEntityMasterData: [],
      clientMasterData: [],
      propertyMasterData: [],
      marketMasterData: [],
      categoryMasterData: [],
      employeeMasterData: [],
      reimburseData: [],
      reimburseFilteredData: [],
      isRender: false,
      count: 0,
      isInAddMode: false,
      defaultSelectedData: [],
      selectedData: [],
      radioValue: 'departmentName',
      reloadTable: false,
      updateAllocation: {
        allocationId: 0,
        allocationType: '',
        billingPercent: 0,
        startDate: moment().format('YYYY/MM/DD')
      },
      updateData: {
        currentPayStart: '',
        allocationId: 0,
        cloudOrgId: 0,
        userEmail: '',
        propertyId: 0,
        employeeId: 0,
        ultiProEmployeeId: null,
        ultiProEmployeeNumber: null,
        cateogry: null,
        allocationStartDate: null,
        allocationEndDate: null,
        billingStartDate: '',
        billingEndDate: null,
        marketAllocationPercent: 0,
        marketBillingPercent: 0,
        propertyAllocationPercent: 0,
        propertyBillingPercent: 0,
        overallMarketAllocationPercent: 0,
        overallMarketBillingPercent: 0,
        overallPropertyAllocationPercent: 0,
        overallPropertyBillingPercent: 0,
        additionalFixedAmount: 0,
        rateValue: 0,
        isReimbursed: false,
        isApproved: true,
        allocationType: 'Property',
        statusId: 0,
        marketId: 0,
        isReimbursedExceed: false,
        flatrateTypeId: null,
        flatrateType: '',
        isAllocatedToLegalEntity: false,
        legalEntityId: 0,
        legalEntityAndPropertyData: null,
        previousIsAllocatedToLegalEntity: false,
        approvalId: 0,
        lastModifiedOn: moment().format('YYYY/MM/DD')
      },
      expand: false,
      varianceColumnsProperty: _.clone(varianceColumnsPropertyList),
      variancePropertyReportConfig: _.clone(variancePropertyReportConfigList),
      filterOnExpand: false,
      payPeriodStartDate: getCurrentPayCycleStartDate(),
      payPeriodEndDate: getCurrentPayCycleEndDate(),
      divisionMasterData: [],
      supervisorEmployeeMasterData: [],
      isAutoRunEnabled: IsAutoRunPagesEnabled(),
      isSubmitButtonClicked: false
    };
  }

  // Handle change event of Radio buttons.
  handleChange = (event, order) => {
    const { varianceColumnsProperty, variancePropertyReportConfig } = this.state;
    variancePropertyReportConfig.groupBy = order;
    const mapOrderData = mapOrder(varianceColumnsProperty, order, 'key');
    this.setState(
      {
        radioValue: event.target.value,
        varianceColumnsProperty: mapOrderData,
        variancePropertyReportConfig
      },
      () => {
        this.forceUpdate();
      }
    );
  };

  // Handle change event of values in Grid table
  handleTableEditChange = (value, fieldName, row, addMode, index) => {
    const param = this.state.updateData;
    if (fieldName === 'propertyBillingPercent' || fieldName === 'marketAllocationPercent') {
      param[fieldName] = value;

      this.setState({ updateData: param, filterOnExpand: false }, () => {
        this.forceUpdate();
      });
    } else {
      this.setState({ filterOnExpand: false }, () => {
        this.forceUpdate();
      });
    }
  };

  // Save updated record
  saveUpdatedRecord = () => {
    let allocationType = '';
    const allocationTypeObj = (this.state.selectedData.find((m) => m.key === 'allocationType') || {});
    if (allocationTypeObj !== undefined && allocationTypeObj.selected !== undefined) {
      allocationType = allocationTypeObj.selected[0].allocationType;
    }
    const newParam = this.state.updateData;
    const param = this.state.updateAllocation;
    param.allocationId = newParam.allocationId;
    param.startDate = moment().format('YYYY/MM/DD');
    param.allocationType = newParam.allocationType;
    param.billingPercent =
      allocationType === 'Property'
        ? newParam.propertyBillingPercent
        : newParam.marketAllocationPercent;

    apiPost({
      url: API_URL.Allocation.UpdateAllocation,
      params: {},
      postBody: param
    }).then(({ data: response }) => {
      // debugger;
      if (response.success === true) {
        ShowToast('Record updated successfully.', toastType.SUCCESS, 5000, 500);

        this.setState({
          updateData: undefined,
          selectedEditRowId: undefined
        }, this.onFilterChange(this.state.selectedData));
      } else {
        ShowToast(response.message, toastType.ERROR, 5000, 5000);
      }
    });
  };

  // Click event of table row. ON clicking it will open details view.
  onRowClick = (data) => {
    this.setState({ detailView: true });
  };

  // Go to grid table. Hide details veiw of record.
  onBackClick = () => {
    this.setState({ detailView: false });
  };

  /**
   * cancel row open for edit mode
   */
  cancelEditMode = () => {
    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateData: undefined
    }, this.onFilterChange(this.state.selectedData));
  };

  // Method to get data before components are mounted
  componentDidMount() {
    this.loadData();
  }

  // Get start and end date of selected pay cycle
  getSelectedPayCycleDate(startDate) {
    startDate = moment(startDate).format('YYYY/MM/DD');
    const date = [];
    const currentMonthStartDate = moment(startDate).startOf('month');
    const previousMonthFDate = moment(startDate)
      .subtract(1, 'months')
      .startOf('month');
    const previousMonthLDate = moment(startDate)
      .subtract(1, 'day');
    const currentMonthMidDate = moment(currentMonthStartDate).add(14, 'days');
    const lastMonthMidDate = moment(previousMonthFDate).add(15, 'days');
    const currentMonthLastDate = moment(startDate).endOf('month');
    if (moment(startDate) >= currentMonthStartDate && moment(startDate) <= currentMonthMidDate) {
      date.push(currentMonthStartDate.format('YYYY/MM/DD'));
      date.push(currentMonthMidDate.format('YYYY/MM/DD'));
      date.push(lastMonthMidDate.format('YYYY/MM/DD'));
      date.push(previousMonthLDate.format('YYYY/MM/DD'));
    } else {
      date.push(currentMonthMidDate.add(1, 'days').format('YYYY/MM/DD'));
      date.push(currentMonthLastDate.format('YYYY/MM/DD'));
      date.push(currentMonthStartDate.format('YYYY/MM/DD'));
      date.push(previousMonthLDate.format('YYYY/MM/DD'));
    }
    return date;
  }

  // Load master data by using API calls
  loadData() {
    const date = getCurrentPayCycle();
    const variancePropertyReportConfig = this.state.variancePropertyReportConfig;
    const selectedData = [];
    let allocationType = '';
    if (IsSectionVisible(SECTIONS.REPORTS, SECTIONS.MARKET_REIMBURSEMENT_VARIANCE_ANALYSIS)) {
      selectedData.push({
        key: 'allocationType',
        selected: [{ allocationType: 'Market' }]
      });
      allocationType = 'Market';
    } else if (IsSectionVisible(SECTIONS.REPORTS, SECTIONS.PROPERTY_REIMBURSEMENT_VARIANCE_ANALYSIS)) {
      selectedData.push({
        key: 'allocationType',
        selected: [{ allocationType: 'Property' }]
      });
      allocationType = 'Property';
      variancePropertyReportConfig.groupBy = ['marketName', 'legalEntity', 'category'];
    }
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Transition.GetClientListingData,
        key: 'clientMasterData'
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData'
      },
      {
        url: API_URL.Property.GetPropertyMasterData,
        key: 'propertyMasterData'
      },
      {
        url: API_URL.Transition.GetCustomerListingData,
        key: 'legalEntityMasterData'
      },      
      {
        url: API_URL.Report.GetPayCycle,
        key: 'lstDateRange'
      },
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true',
        key: 'employeeMasterData'
      },
      {
        url: API_URL.Allocation.GetDivisions,
        key: 'divisionMasterData'
      }
    ])
      .then(
        ({
          marketMasterData,
          clientMasterData,
          propertyMasterData,
          legalEntityMasterData,
          lstDateRange,
          employeeMasterData,
          divisionMasterData
        }) => {
          this._asyncRequest = null;
          if (marketMasterData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }

          lstDateRange.data = (lstDateRange.data || []).filter(x => x.payCycleEnd !== x.payCycleStart);
          selectedData.push({
            key: 'payCycle',
            selected: (lstDateRange.data.find(x => x.payCycle === (date[1] + '-' + date[0])) || {})
          });

          employeeMasterData?.data?.forEach(x => {
            x.preferredName = x.employeeName;
          });
          this.setState({
            dateRangePrior: lstDateRange.data,
            dateRangeNext: lstDateRange.data,
            defaultSelectedData: cloneDeep(selectedData),
            propertyMasterData: propertyMasterData.data || [],
            clientMasterData: clientMasterData.data || [],
            marketMasterData: marketMasterData.data || [],
            legalEntityMasterData: legalEntityMasterData.data || [],            
            isRender: true,
            payPeriodStartDate: date[1],
            payPeriodEndDate: date[0],
            selectedData: selectedData || [],
            variancePropertyReportConfig,
            employeeMasterData: cloneDeep(employeeMasterData.data || []),
            divisionMasterData: divisionMasterData.data,
            supervisorEmployeeMasterData: cloneDeep(employeeMasterData.data || [])
          }, () => {
            if(this.state.isAutoRunEnabled || this.state.isSubmitButtonClicked) {
              this.onFilterChangeData(selectedData, allocationType);
            }
          });
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // This method is called if Auto-Run of pages is enabled.
  // Method is used Reset all filters and show the message to click on Button to view data.
  resetPage = (selectedData)=> {
    let allocationType = '';
    let variancePropertyReportConfig;
    const allocationTypeObj = (selectedData.find((m) => m.key === 'allocationType') || {});
    if (allocationTypeObj !== undefined && allocationTypeObj.selected !== undefined) {
      allocationType = allocationTypeObj.selected[0].allocationType;
    }
    if (allocationType === 'Market') {
      variancePropertyReportConfig = _.cloneDeep(variancePropertyReportConfigList);
      const mapOrderData = mapOrder(this.state.varianceColumnsProperty, variancePropertyReportConfigList.groupBy, 'key');
      this.setState({ expand: false, reloadTable: !this.state.reloadTable, selectedData, variancePropertyReportConfig, 
        radioValue: 'departmentName', varianceColumnsProperty: mapOrderData, selectedEditRowId: undefined, 
        reimburseData: [], reimburseFilteredData: [], isSubmitButtonClicked: false
      });
    } else if (allocationType === 'Property') {
      variancePropertyReportConfig = _.cloneDeep(variancePropertyReportConfigList);
      const obj = radioValue.find(x => x.value === 'customer' && x.showWhen.allocationType === 'Property');
      variancePropertyReportConfig.groupBy = obj.sortOrder;
      const mapOrderData = mapOrder(this.state.varianceColumnsProperty, obj.sortOrder, 'key');
      this.setState({ expand: false, reloadTable: !this.state.reloadTable, selectedData, variancePropertyReportConfig, radioValue: 'customer', varianceColumnsProperty: mapOrderData, selectedEditRowId: undefined,
        reimburseData: [], reimburseFilteredData: [], isSubmitButtonClicked: false
      });
    } else {
      this.setState({ selectedData, expand: false, reloadTable: !this.state.reloadTable, reimburseData: [], reimburseFilteredData: [], isSubmitButtonClicked: false });
    }
  }

  // Event to handle change in filter values
  onFilterChange = (selectedData) => {
    let allocationType = '';
    let variancePropertyReportConfig;
    const allocationTypeObj = (selectedData.find((m) => m.key === 'allocationType') || {});
    if (allocationTypeObj !== undefined && allocationTypeObj.selected !== undefined) {
      allocationType = allocationTypeObj.selected[0].allocationType;
    }
    if (allocationType === 'Market') {
      selectedData = selectedData.filter(x=> x.key !== 'customerName');
      variancePropertyReportConfig = _.cloneDeep(variancePropertyReportConfigList);
      const mapOrderData = mapOrder(this.state.varianceColumnsProperty, variancePropertyReportConfigList.groupBy, 'key');
      this.setState({ expand: false, reloadTable: !this.state.reloadTable, selectedData, variancePropertyReportConfig, radioValue: 'departmentName', varianceColumnsProperty: mapOrderData, selectedEditRowId: undefined }, () => {
        this.onFilterChangeData(selectedData, allocationType);
      });
    } else if (allocationType === 'Property') {
      selectedData = selectedData.filter(x=> x.key !== 'division');
      variancePropertyReportConfig = _.cloneDeep(variancePropertyReportConfigList);
      const obj = radioValue.find(x => x.value === 'customer' && x.showWhen.allocationType === 'Property');
      variancePropertyReportConfig.groupBy = obj.sortOrder;
      const mapOrderData = mapOrder(this.state.varianceColumnsProperty, obj.sortOrder, 'key');
      this.setState({ expand: false, reloadTable: !this.state.reloadTable, selectedData, variancePropertyReportConfig, radioValue: 'customer', varianceColumnsProperty: mapOrderData, selectedEditRowId: undefined }, () => {
        this.onFilterChangeData(selectedData, allocationType);
      });
    } else {
      this.setState({ selectedData, expand: false, reloadTable: !this.state.reloadTable }, () => {
        this.onFilterChangeData(selectedData, allocationType);
      });
    }
  };

  // Get data from API based on selected filters
  onFilterChangeData = (selectedData, allocationType) => {
    const datevalue = selectedData.find((m) => m.key === 'payCycle');
    const date = getCurrentPayCycle();
    const lstDateRange = this.state.dateRangeNext;
    let startDate = [];

    if (datevalue?.selected?.length <= 0 || datevalue?.selected?.payCycle === undefined) {
      startDate.push(date[1]);
      startDate.push(date[0]);
      selectedData.push({
        key: 'payCycle',
        selected: (lstDateRange.find(x => x.payCycle === (date[1] + '-' + date[0])) || {})
      });
    } else {
      startDate = datevalue?.selected?.payCycle?.split('-');
    }
    const ultiProEmployee = selectedData.find((m) => m.key === 'ultiProEmployeeId');
    let supervisorId = '';

    if (ultiProEmployee !== undefined && ultiProEmployee?.selected?.length > 0) {
      supervisorId = (ultiProEmployee.selected.map(x => x.ultiProEmployeeId))?.join('|');
    }
    let showTrueUpCredit = false;
    if (allocationType === 'Property'){
      const showTrueUpCreditObj = selectedData.find((m) => m.key === 'showTrueUpCredit');
      if(showTrueUpCreditObj !== undefined && showTrueUpCreditObj?.selected?.length > 0){
        showTrueUpCredit = showTrueUpCreditObj?.selected[0]?.showTrueUpCredit;
      }
    } 
    else {
      showTrueUpCredit = false;
    }
    this._asyncRequest = apiBatchRequest([
      {
        url:
          API_URL.Allocation.GetPreBillingData +
          '?CurrentPayStart=' +
          startDate[0] +
          '&CurrentPayEnd=' +
          startDate[1] +
          '&AllocationType=' +
          allocationType +
          '&supervisorId=' +
          supervisorId +
          '&showTrueUpCredit=' +
          showTrueUpCredit,
        key: 'reimburseData'
      }
    ])
      .then(({ reimburseData }) => {
        this._asyncRequest = null;
        if (reimburseData.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        this.filterData(
          reimburseData.data,
          selectedData,
          startDate[0],
          startDate[1]
        );
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // Download report file in pdf or excel format
  downloadFile = (fileMimeType, type, isPrint = false) => {
    const selectedData = this.state.selectedData;
    const datevalue = selectedData.find((m) => m.key === 'payCycle');
    const date = getCurrentPayCycle();
    const lstDateRange = this.state.dateRangeNext;
    let startDate = [];

    if (datevalue.selected.length <= 0) {
      startDate.push(date[1]);
      startDate.push(date[0]);
      selectedData.push({
        key: 'payCycle',
        selected: (lstDateRange.find(x => x.payCycle === (date[1] + '-' + date[0])) || {})
      });
    } else {
      startDate = datevalue.selected.payCycle.split('-');
    }
    const date1 = this.getSelectedPayCycleDate(moment(startDate[0]).format('YYYY-MM-DD'));
    const ultiProEmployee = selectedData.find((m) => m.key === 'ultiProEmployeeId');
    let supervisorId = '';
    if (ultiProEmployee?.selected?.length > 0) {
      supervisorId = (ultiProEmployee.selected.map(x => x.ultiProEmployeeId))?.join('|');
    }
    // return false;
    const dataValue = [
      { key: 'CurrentPayStart', value: startDate[0] },
      { key: 'CurrentPayEnd', value: startDate[1] },
      { key: 'PreviousPayStart', value: date1[2] },
      { key: 'PreviousPayEnd', value: date1[3] },
      { key: 'supervisorId', value: supervisorId }
    ];

    const allocationTypeObj = (selectedData.find((m) => m.key === 'allocationType') || {});
    let allocationType = '';
    if (allocationTypeObj !== undefined && allocationTypeObj.selected !== undefined) {
      allocationType = allocationTypeObj.selected[0].allocationType;
      if (allocationType !== undefined) {
        dataValue.push({ key: 'AllocationType', value: allocationType });
      }
      dataValue.push({ key: 'ShowSensitiveData', value: IsSensitiveDataAccess() });
    }

    let showTrueUpCredit = false;
    if (allocationType === 'Property'){
      const showTrueUpCreditObj = selectedData.find((m) => m.key === 'showTrueUpCredit');
      if(showTrueUpCreditObj !== undefined && showTrueUpCreditObj?.selected?.length > 0){
        showTrueUpCredit = showTrueUpCreditObj?.selected[0]?.showTrueUpCredit;
      }
      dataValue.push({ key: 'ShowTrueUpCredit', value: showTrueUpCredit });
    } 

    const marketNameObj = (selectedData.find((m) => m.key === 'marketName') || {});
    if (marketNameObj !== undefined && marketNameObj.selected !== undefined && marketNameObj.selected.length > 0) {
      const marketId = marketNameObj.selected.map(x => x.marketId);
      dataValue.push({ key: 'MarketId', value: marketId.join('|') });
    }

    const propertyObj = (selectedData.find((m) => m.key === 'propertyName') || {});

    if (propertyObj !== undefined && propertyObj.selected !== undefined && propertyObj.selected.length > 0) {
      const propertyId = propertyObj.selected.map(x => x.propertyId);
      dataValue.push({ key: 'PropertyId', value: propertyId.join('|') });
    }

    const clientObj = (selectedData.find((m) => m.key === 'clientName') || {});
    if (clientObj !== undefined && clientObj.selected !== undefined && clientObj.selected.length > 0) {
      const clientId = clientObj.selected.map(x => x.clientId);
      dataValue.push({ key: 'ClientId', value: clientId.join('|') });
    }

    const legalEntityObj = (selectedData.find((m) => m.key === 'customerName') || {});
    if (legalEntityObj !== undefined && legalEntityObj.selected !== undefined && legalEntityObj.selected.length > 0) {
      const legalEntityId = legalEntityObj.selected.map(x => x.customerId);
      dataValue.push({ key: 'LegalEntityId', value: legalEntityId.join('|') });
    }
    const employeeObj = (selectedData.find((m) => m.key === 'preferredName') || {});
    if (employeeObj !== undefined && employeeObj.selected !== undefined && employeeObj.selected.length > 0) {
      const employeeId = employeeObj.selected.map(x => x.employeeId);
      dataValue.push({ key: 'EmployeeId', value: employeeId.join('|') });
    }

    if (allocationType === 'Market') {
      const divisionObj = (selectedData.find((m) => m.key === 'division') || {});

      if (divisionObj !== undefined && divisionObj.selected !== undefined && divisionObj.selected.length > 0) {
        const divisionId = divisionObj.selected.map(x => x.divisionId);
        dataValue.push({ key: 'DivisionId', value: divisionId.join('|') });
      }
    }

    const groupByData = radioValue.find(x => x.value === this.state.radioValue);
    if (groupByData !== undefined) {
      dataValue.push({ key: 'GroupBy', value: groupByData.groupBy.join('|') });
    }

    const url = GenerateAbsoluteURL(dataValue, [], allocationType + '%20Reimbursement%20Variance%20Analysis', type);
    downloadReport(
      url,
      (allocationTypeObj?.selected[0]?.allocationType || '') + ' Reimbursement Variance Analysis Report',
      fileMimeType,
      type,
      isPrint
    );
  }

  // Filter records from original response records based on selected filters.
  filterData(
    responseReimburseData,
    selectedData,
    payPeriodStartDate,
    payPeriodEndDate
  ) {
    const filteredData = applyFilterOnData(
      [...responseReimburseData],
      selectedData
    );
    this.setState(
      {
        reimburseData: filteredData,
        selectedData: selectedData,
        reloadTable: !this.state.reloadTable,
        responseReimburseData: responseReimburseData,
        payPeriodStartDate,
        payPeriodEndDate
      },
      () => {
        this.forceUpdate();
      }
    );
  }

  // Method to expand the records
  expandAll = () => {
    this.setState({
      filterOnExpand: true,
      expand: !this.state.expand,
      reloadTable: !this.state.reloadTable
    });
  }

  // Render action buttons into the column based on conditions per row
  renderActionColumn = (cellInfo, key, isInAddMode) => {
    let showAdd = false;
    const selectedData = this.state.selectedData;
    const datevalue = selectedData.find((m) => m.key === 'payCycle');
    const date = getCurrentPayCycle();
    let startDate = [];

    if (datevalue.selected.length <= 0) {
      startDate.push(date[1]);
      startDate.push(date[0]);
    } else {
      startDate = datevalue.selected.payCycle.split('-');
    }
    const currentPay = Operators.GreaterThanEqualsTo(new Date(startDate[1]).getTime(),
      new Date(date[0]).getTime());
    if (currentPay.result) {
      if (cellInfo.allocationType === 'Market') {
        showAdd = IsSectionVisible(SECTIONS.REPORTS, SECTIONS.MARKET_REIMBURSEMENT_VARIANCE_ANALYSIS, SECTIONS.ADD_EDIT);
        if (cellInfo.allocationEndDate !== null) {
          const res = Operators.GreaterThanEqualsTo(new Date(cellInfo.allocationEndDate).getTime(),
            (new Date(getCurrentPayCycleStartDate()?.format('MM/DD/YYYY'))).getTime());
          showAdd = res.result;
        }
      } else if (cellInfo.allocationType === 'Property') {
        showAdd = IsSectionVisible(SECTIONS.REPORTS, SECTIONS.PROPERTY_REIMBURSEMENT_VARIANCE_ANALYSIS, SECTIONS.ADD_EDIT);
        const res = Operators.GreaterThanEqualsTo(new Date(cellInfo.billingEndDate).getTime(),
          (new Date(getCurrentPayCycleStartDate()?.format('MM/DD/YYYY'))).getTime());
        showAdd = (cellInfo.billingEndDate === null || res.result);
      }
    }
    return (
      <>
        {this.state.selectedEditRowId !== undefined &&
          cellInfo.allocationId === this.state.selectedEditRowId.value
          ? (
            <>
              <Tooltip title="Save Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={this.saveUpdatedRecord}
                >
                  <SaveIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={this.cancelEditMode}
                >
                  <CancelIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            </>
          )
          : showAdd
            ? (
              <Tooltip title="Edit Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    this.setState({
                      selectedEditRowId: {
                        key: 'allocationId',
                        value: cellInfo.allocationId
                      },
                      isInAddMode: false,
                      updateData: cellInfo
                    });
                  }}
                >
                  <EditIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            )
            : null}
      </>
    );
  };

  // Go to the report list page
  goBack = () => {
    this.setState({
      showMain: true
    });
  };

  // Render method to render the components
  render() {
    const {
      dateRangePrior,
      dateRangeNext,
      propertyMasterData,
      legalEntityMasterData,
      clientMasterData,
      marketMasterData,
      reimburseData,
      configuration,
      selectedData,
      varianceColumnsProperty,
      variancePropertyReportConfig,
      showMain,
      employeeMasterData,
      divisionMasterData,
      supervisorEmployeeMasterData
    } = this.state;
    let varianceColumnsPropertyData = varianceColumnsProperty;
    if (!IsSensitiveDataAccess()) {
      varianceColumnsPropertyData = varianceColumnsProperty.filter(x => x.key !== 'reimbursement' && x.key !== 'priorPeriodReimburse' && x.key !== 'variance' && x.key !== 'additionalFixedAmount');
    }
    const EditSource = [];
    EditSource.push({
      key: 'reimburseData',
      data: reimburseData
    });
    const searchAllocationRadio = [];

    if (IsSectionVisible(SECTIONS.REPORTS, SECTIONS.MARKET_REIMBURSEMENT_VARIANCE_ANALYSIS)) {
      searchAllocationRadio.push({ value: 'Market', title: 'Market Allocation' });
    }
    if (IsSectionVisible(SECTIONS.REPORTS, SECTIONS.PROPERTY_REIMBURSEMENT_VARIANCE_ANALYSIS)) {
      searchAllocationRadio.push({ value: 'Property', title: 'Property Allocation' });
    }

    let allocationType = '';
    const allocationTypeObj = (selectedData.find((m) => m.key === 'allocationType') || {});
    if (allocationTypeObj !== undefined && allocationTypeObj.selected !== undefined) {
      allocationType = allocationTypeObj.selected[0].allocationType;
    }
    // const showAdd = false;
    const hiddenConfig = [];
    hiddenConfig.push({
      key: 'allocationType',
      value: allocationType
    });
    return (
      <>
        {showMain
          ? (
            <Reports />
          )
          : (<>

            <PageHeader
              key={'Reimbursement_Variance_Analysis'}
              title={'Reimbursement Variance Analysis Report'}
              actionsConfig={[
                {
                  icon: (
                    <ArrowBackIcon
                      size="small"
                      className="back-button no-print"
                    />
                  ),
                  onClick: this.goBack,
                  title: 'Back to Report'
                }
              ]}
            >
              Reimbursement Variance Analysis Report
            </PageHeader>
            {propertyMasterData && (
              <PageFilter
                hidePanel={true}
                autoFilter={false}
                filterAlwaysVisible={this.props.renderAsChild !== true}
                onFilterChanged={this.onFilterChange}
                resetPage={this.state.isAutoRunEnabled ? undefined : this.resetPage}
                filterConfig={[
                  {
                    type: controlType.RadioButton,
                    key: 'allocationType',
                    options: searchAllocationRadio,
                    placeholder: 'Search Property',
                    title: 'Allocation Type',
                    isHandleClick: true,
                    hiddenWhenChild: this.props.renderAsChild === true
                  },
                  {
                    multiple: true,
                    type: controlType.DropDown,
                    source: marketMasterData,
                    key: 'marketName',
                    placeholder: 'Search Market',
                    title: 'Market'
                  },
                  {
                    multiple: true,
                    type: controlType.DropDown,
                    source: divisionMasterData,
                    key: 'division',
                    placeholder: 'Search Division',
                    title: 'Division',
                    hidewhen: { key: 'allocationType', value: 'Property' }

                  },
                  {
                    multiple: true,
                    type: controlType.DropDown,
                    source: employeeMasterData,
                    key: 'preferredName',
                    checkString: true,
                    placeholder: 'Search Employee',
                    title: 'Employee',
                    ignoreFilters: ['marketName', 'clientName', 'propertyName', 'customerName']
                  },
                  {
                    multiple: true,
                    type: controlType.DropDown,
                    source: legalEntityMasterData,
                    key: 'customerName',
                    placeholder: 'Search Legal Entity',
                    title: 'Legal Entity',
                    hidewhen: { key: 'allocationType', value: 'Market' }

                  },
                  {
                    multiple: true,
                    type: controlType.DropDown,
                    source: supervisorEmployeeMasterData,
                    key: 'ultiProEmployeeId',
                    filterOnKey: 'supervisorId',
                    displayValue: 'employeeName',
                    placeholder: 'Search Supervisor',
                    title: 'Supervisor',
                    alwaysFromServer: true
                  },
                  {
                    multiple: false,
                    type: controlType.DropDown,
                    source: dateRangeNext,
                    key: 'payCycle',
                    placeholder: 'Pay Period',
                    title: 'Pay Period',
                    ignoreSort: true,
                    disableClearable: true
                  },
                  {
                    type: controlType.Checkbox,
                    key: 'isReimbursedExceed',
                    placeholder: 'Search Property',
                    title: 'Show only Threshold Exceeded'
                  },
                  {
                    type: controlType.Checkbox,
                    key: 'showTrueUpCredit',
                    placeholder: 'Show Detailed TrueUp/Credit Records',
                    title: 'Show Detailed TrueUp/Credit Records',
                    hidewhen: { key: 'allocationType', value: 'Market' }
                  }
                ]}
                defaultSelectedData={this.state.defaultSelectedData}
                selectedData={this.state.selectedData}
                gridColumn={3}
              ></PageFilter>
            )}
            <div className="row pageFilter-container bottom-xs start-xs">
              <div className="col-sm-9 default-text">
                <FormControl component="fieldset">
                  <RadioGroup
                    row
                    aria-label="position"
                    name="position"
                    value={this.state.radioValue}
                  >
                    {(radioValue || []).map((col, i) =>
                      col.showWhen === undefined || col.showWhen.allocationType === undefined || col.showWhen.allocationType === allocationType

                        ? (
                          <FormControlLabel
                            value={col.value}
                            control={<Radio color="primary"
                              onChange={(event) => {
                                this.handleChange(event, col.sortOrder);
                              }} />}
                            label={col.label}
                            labelPlacement="end"
                          />
                        )
                        : (
                          <></>
                        )
                    )}
                  </RadioGroup>
                </FormControl>
              </div>
              {/* <div className="col-sm-2"></div> */}

              {reimburseData !== null && reimburseData?.length > 0 && <div className="col-sm-3 end-xs">
                <FormControlLabel
                  key={'checkbox_'}
                  value={this.state.expand}
                  style={{ fontSize: '0.768rem' }}
                  control={
                    <Checkbox
                      color="primary"
                      checked={this.state.expand}
                      onChange={this.expandAll}
                    />
                  }
                  label={'Expand All'}
                  labelPlacement="end"
                />
                <Tooltip title="Export Excel" placement="top">
                  <IconButton size="small" onClick={() => this.downloadFile('application/vnd.ms-excel', 'Excel', false)}>
                    <AssignmentIcon
                      style={{ fontSize: '1.768rem', color: '#05375E' }}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Export Pdf" placement="top">
                  <IconButton size="small" onClick={() => this.downloadFile('application/pdf', 'Pdf', false)}>
                    <PictureAsPdfIcon
                      style={{ fontSize: '1.768rem', color: '#05375E' }}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Print" placement="top">
                  <IconButton size="small" onClick={() => this.downloadFile('application/pdf', 'Pdf', true)}>
                    <PrintIcon style={{ fontSize: '1.768rem', color: '#05375E' }}
                    />
                  </IconButton>
                </Tooltip>
              </div>}
            </div>
            {/* If Auto Run is not enabled and buttons not clicked, then show message to click button */}
            {(this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === false) && 
                (reimburseData === null || reimburseData.length <= 0) && (
                  <PageLandingMessage buttonName={'SEARCH'}/>
                )
            }
            { reimburseData !== null && reimburseData?.length > 0 &&
            <div className="row table-list-container">
              <GridEditTable
                columns={UpdateColumnWithConfiguration(
                  varianceColumnsPropertyData,
                  configuration,
                  hiddenConfig || []
                )}
                isInline={true}
                selectedEditRowId={this.state.selectedEditRowId}
                renderActionColumn={this.renderActionColumn}
                tableData={reimburseData}
                config={variancePropertyReportConfig}
                rowsPerPageList={[25, 50, 100]}
                isInAddMode={this.state.isInAddMode}
                EditSource={EditSource}
                handleTableEditChange={this.handleTableEditChange}
                updateData={this.state.updateData}
                reload={this.state.reloadTable}
                expand={this.state.expand}
                filterOnExpand={this.state.filterOnExpand}
              />
            </div>
            }
          </>)
          }
      </>
    );
  }
}
export default ReimbursementVarianceAnalysis;
